// Mapping function to convert database field names to user-friendly display names
export const getFieldDisplayName = (fieldName) => {
  const fieldMappings = {
    // Site Information
    site_code: 'Site Code',
    physical: 'Physical',
    vendor: 'Vendor',
    region: 'Region',
    coverage_type: 'Coverage Type',
    site_status: 'Site Status',

    // Location Information
    lat: 'Latitude',
    long: 'Longitude',
    commercial_district: 'Commercial District',
    commercial_city: 'Commercial City',
    pta_tehsil: 'PTA Tehsil',
    pta_district: 'PTA District',
    pta_province: 'PTA Province',
    city_prefix_based: 'City Prefix Based',
    technical_city: 'Technical City',

    // Business Information
    mbu: 'MBU',
    franchise_id: 'Franchise ID',
    prefix: 'Prefix',

    // Site Configuration
    site_type: 'Site Type',
    sharing_type_hostguest: 'Sharing Type (Host/Guest)',
    omo_name: 'OMO Name',
    b2s_id: 'B2S ID',
    bsc: 'BSC',
    bsc_code: 'BSC Code',

    // Status and Technology
    locked_status: 'Locked Status',
    lte_technology: 'LTE Technology',
    deodar_tag: 'Deodar Tag',

    // Additional fields that might be present
    status: 'Status',
    usf_site: 'USF Site',
    fiber_type: 'Fiber Type',
    planning_status: 'Planning Status',
    implementation_phase: 'Implementation Phase',
    estimated_cost: 'Estimated Cost',
    onfp_planning_remarks: 'ONFP Planning Remarks',
    bp_remarks: 'BP Remarks',
    comments: 'Comments',
    commercial_subregion: 'Commercial Subregion',
    scope: 'Scope',
    pta_remarks: 'PTA Remarks',
    '2g_locked_tag': '2G Locked Tag',
    '4g_locked_tag': '4G Locked Tag',
    '2g': '2G',
    '4g': '4G',
    site_from: 'Site From',
    site_to: 'Site To',
    '4g_capacity': '4G Capacity',
    '2g_cells': '2G Cells',
    '4g_cells': '4G Cells',
    l1800a_cells: 'L1800A Cells',
    l1800b_cells: 'L1800B Cells',
    mmcells: 'MM Cells',
    total_l18_ab_cells: 'Total L18 AB Cells',
    l2100_cells: 'L2100 Cells',
    l900a_cells: 'L900A Cells',
    total_trx: 'Total TRX',
    '900_trx': '900 TRX',
    '1800_trx': '1800 TRX',
    part_of_dec_cfo: 'Part of DEC CFO',
    ring_name: 'Ring Name',
    fiber_pop_id: 'Fiber POP ID',
  };

  // Return the mapped name if it exists, otherwise format the field name
  if (fieldMappings[fieldName]) {
    return fieldMappings[fieldName];
  }

  // Fallback: convert snake_case to Title Case
  return fieldName
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// Function to get all available field mappings
export const getAllFieldMappings = () => {
  return {
    site_code: 'Site Code',
    physical: 'Physical',
    vendor: 'Vendor',
    region: 'Region',
    coverage_type: 'Coverage Type',
    site_status: 'Site Status',
    lat: 'Latitude',
    long: 'Longitude',
    commercial_district: 'Commercial District',
    commercial_city: 'Commercial City',
    mbu: 'MBU',
    franchise_id: 'Franchise ID',
    pta_tehsil: 'PTA Tehsil',
    pta_district: 'PTA District',
    pta_province: 'PTA Province',
    prefix: 'Prefix',
    city_prefix_based: 'City Prefix Based',
    technical_city: 'Technical City',
    site_type: 'Site Type',
    sharing_type_hostguest: 'Sharing Type (Host/Guest)',
    omo_name: 'OMO Name',
    b2s_id: 'B2S ID',
    bsc: 'BSC',
    bsc_code: 'BSC Code',
    locked_status: 'Locked Status',
    lte_technology: 'LTE Technology',
    deodar_tag: 'Deodar Tag',
  };
};
